import { Box, Card, Grid, IconButton, Stack, Table, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import Iconify from '../iconify';
import { useBoolean } from '../../hooks/useBoolean';
import CustomSmallSelect from '../custom-input/CustomSmallSelect';
import { blueGrey, grey } from '@mui/material/colors';
import { fNumber } from '../../utils/formatNumber';
import { getAnaltyicsDatabyLocationbyMotive, onGetCurrentPeriod, onGetFirstTimeAndFollowUpPatients } from '../../pages/Programs/AnalyticsBusinessProgramPage/analytics_utils';
import TableHeadCustom from '../table/TableHeadCustom';


const RegionReport = ({
    period,
    locations,
    onReturn,
    appointments,
    program_users,
}) => {

    const loading = useBoolean()
    const [data, setDate] = useState()

    const [imc_data, setIMCData] = useState([
        {
            name:'Anterior',
            group:'previous',
            data:[],
        },
        {
            name:'Actual',
            group:'current',
            data:[],
        },
    ])

    //const [locations, setLocations] = useState([])
    const [locations_data, setLocationsData] = useState([])
    const [selected, setSelected] = useState(-1)
    const [current_analytics, setCurrentAnalytics] = useState([])

    const _location = locations_data.find(el => el.id_client_location === selected)

    const [first_time_data, setFirstTimeData] = useState([])
    const [follow_up_data, setFollowUpData] = useState([])


    const onGetLocalData = useCallback(() => {
        
        const validPeriod = onGetCurrentPeriod(period)
        console.log(locations)

        const {follow_up_users, first_time_users, valid_period_appointments, scheduled_appointments} = onGetFirstTimeAndFollowUpPatients(program_users, appointments, validPeriod)
        //console.log(first_time_users)
        const result_first = getAnaltyicsDatabyLocationbyMotive(first_time_users, selected)
        const result_follow = getAnaltyicsDatabyLocationbyMotive(follow_up_users, selected)
        setFirstTimeData(result_first)
        setFollowUpData(result_follow)

    },[period, appointments, program_users, locations, selected])

    
    useEffect(() => {
        onGetLocalData()
    }, [selected])

    const _locations = [
        {id_client_location:-1, name:'Sin sitio'},
        ...locations
    ]

    const selected_location = _locations.find(el => el.id_client_location === selected)

    return ( 
        <Box>
            <Stack direction='row'>
                <IconButton onClick={onReturn}>
                    <Iconify icon="material-symbols:arrow-back-rounded" />
                </IconButton>
                <Typography variant='h5' sx={{flex:1}}>
                    Datos por Región
                </Typography>
                <Stack direction='row' justifyContent='flex-end'>
                    <CustomSmallSelect label='Región' value={selected} onChange={(e) => setSelected(parseInt(e.target.value))}>
                        {_locations.map((location) => (
                            <option key={location.id_client_location} value={location.id_client_location}>
                                {location.name}
                            </option>
                        ))}
                    </CustomSmallSelect>
                    
                </Stack>
                
                
            </Stack>
            <Stack spacing={3} sx={{my:2}}>
                <Typography variant='h5' sx={{mb:1}}>
                    {selected_location?.name ?? ""}
                </Typography>
                <AnalyticTable 
                    title={"Colaboradores de primera vez"}
                    data={first_time_data}
                
                />
                <AnalyticTable 
                    title={"Colaboradores en seguimiento"}
                    data={follow_up_data}
                
                />
            </Stack>
            
        </Box>
     );
}
 
export default RegionReport;

const AnalyticTable = ({
    title,
    data
}) => {
    return(
        <Box>
            <Typography variant='h6' gutterBottom>{title}</Typography>
            <Card sx={{overflow:'auto'}}>
                <TableContainer sx={{position: 'relative', overflow: 'unset'  }}>
                    <Table stickyHeader size={'small'} sx={{ minWidth: 800}}>
                        <TableHeadCustom
                            headLabel={TABLE_HEAD}
                        />
                        {data.map((row) => (
                            <TableRow key={row[0]}>
                                {row.map(dat => {
                                    if(typeof(dat) === 'number') return <TableCell sx={{borderBottom:`1px solid ${grey[300]}`}}>{fNumber(dat,'0,0.00')}</TableCell>
                                    return <TableCell sx={{borderBottom:`1px solid ${grey[300]}`}}>{dat}</TableCell>
                                })}
                            </TableRow>
                        ))}
                            
                    </Table>
                </TableContainer>
            </Card>
        </Box>
    )
}

const TABLE_HEAD = [
    { id: '', label: '', align: 'left' },
    { id: 'patients', label: 'Total de pacientes', align: 'left' },
    { id: 'weight', label: 'Peso Total en Kg ', align: 'left' },
    { id: 'imc', label: 'Promedio IMC', align: 'left' },
    { id: 'diagnostic_imc', label: 'Diagnóstico IMC', align: 'left' },
    { id: 'waist', label: 'Suma Circ. Cintura', align: 'left' },
    { id: 'hips', label: 'Suma Circ. Cadera', align: 'left' },
    { id: 'icc', label: 'Promedio ICC', align: 'left' },
    { id: 'fat', label: 'Kg grasa', align: 'left' },
    { id: 'muscle', label: 'Kg músculo', align: 'left' },

    
];

const AverageMetricCard = ({
    icon,
    title,
    value,
    diagnosis
}) => {
    return(
        <Card sx={{
            p:2
        }}>
            <Grid container>
                <Grid item>
                    <Box sx={{p:1}}>
                        <Iconify icon={icon} color={blueGrey[600]} width={42}/>
                    </Box>
                </Grid>
                <Grid item xs>
                    <Typography variant='subtitle1'>
                        {title} del periodo actual
                    </Typography>
                    <Typography variant='body1' color={'text.secondary'}>
                        {value} {diagnosis}
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    )
}





{/*<LoadingContainer loading={loading.value}>
    <Stack>
        <RegionMCBarChart 
            data={imc_data}
            locations={locations}
        />
        <Box>
            <Stack direction='row' justifyContent='flex-end'>
                <CustomSmallSelect label='Región' value={selected} onChange={(e) => setSelected(parseInt(e.target.value))}>
                    {locations_data.map((location) => (
                        <option key={location.id_client_location} value={location.id_client_location}>
                            {location.name}
                        </option>
                    ))}
                </CustomSmallSelect>
                
            </Stack>
            <Box>
                
                <Typography variant='h5' gutterBottom>
                    Región {_location?.name}
                </Typography>
                <Box sx={{pb:2}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <AverageMetricCard 
                                title="IMC promedio"
                                icon="fa-solid:weight"
                                value={fNumber(_analytic?.average_imc ?? 0, '0.00')}
                                
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <AverageMetricCard 
                                title="ICC promedio"
                                icon="icon-park-outline:waistline"
                                value={fNumber(_analytic?.average_icc ?? 0, '0.00')}
                                
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <AverageMetricCard 
                                title="% grasa promedio"
                                icon="fa-solid:percentage"
                                value={fNumber(_analytic?.average_percentage_fat ?? 0, '0.00')}
                                
                            />
                        </Grid>
                    </Grid>
                </Box>
                <RegionIMCbyLocation 
                    idclient={idclient} 
                    idclientprogram={idclientprogram} 
                    idclientlocation={selected}
                    period={period}
                />
            </Box>
        </Box>
    </Stack>
    
</LoadingContainer>*/}


/*
    const initialize = useCallback(async() => {
            const month = number2Digits((period?.month ?? 0)+1)
            const year = period?.year
            const startdate = `${year}-${month}-01` 
            const enddate = moment(startdate).endOf('month').format('YYYY-MM-DD')

            const startdate_previous = moment(startdate).subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
            const enddate_previous = moment(startdate).subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
    
            loading.onTrue()

            
            try {

                const _locations = await getClientLocations(idclient, {order:0, order_by:JSON.stringify(['name'])})
                console.log(_locations)
                setLocationsData(_locations.data)
                if(_locations.data ) setSelected(_locations.data[0].id_client_location)
                const _locationslabel = _locations.data.map(item => item.name)
                setLocations(_locationslabel)

    
                const _locatationdata_current = await getAnalyticsLocationAverageMetrics({
                    start_date:startdate,
                    end_date:enddate,
                    client_id:idclient,
                    client_program_id:idclientprogram
                })

                const _locatationdata_prev = await getAnalyticsLocationAverageMetrics({
                    start_date:startdate_previous,
                    end_date:enddate_previous,
                    client_id:idclient,
                    client_program_id:idclientprogram
                })
                setCurrentAnalytics(_locatationdata_current)
                //console.log(_patientdata)
                //setGlobalPatient(_patientdata)

                let _imc_prev = []
                let _imc_current = []

                for(let i=0; i<_locations.data.length; i++){
                    const _location = _locations.data[i]
                    let _findPrev = _locatationdata_prev.find(el => el.client_location_id === _location.id_client_location)
                    let _findCurrent = _locatationdata_current.find(el => el.client_location_id === _location.id_client_location)
                    console.log(_findPrev)
                    console.log(_findCurrent)
                    if(_findCurrent){
                        //console.log("Se encontró current")
                        _imc_current.push(Number(_findCurrent?.average_imc ?? 0))
                    }else{
                        _imc_current.push(0)
                    }
                    if(_findPrev){
                        //console.log("Se encontró prev")
                        _imc_prev.push(Number(_findPrev?.average_imc ?? 0))
                    }else{
                        _imc_prev.push(0)
                    }

                }

                setIMCData([
                    {
                        name:'Anterior',
                        group:'previous',
                        data:_imc_prev,
                    },
                    {
                        name:'Actual',
                        group:'current',
                        data:_imc_current,
                    },
                ])
                
            } catch (error) {
                console.log(error)
            }
    
            
            
           
            loading.onFalse()
    
        }, [period, idclient, idclientprogram])
    
        useEffect(() => {
            initialize()
        }, [])
*/